import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Button } from './Button';
const CHECKOUT_URL = 'https://www.lunaycalma.com/cart/46841754419354:1';
export function GuaranteeSection() {
  return <section className="w-full py-20 bg-gradient-to-br from-navy-900 to-magenta-900 text-white" data-id="element-160">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-161">
        <div className="inline-block mb-6" data-id="element-162">
          <ShieldCheckIcon className="w-20 h-20 text-gold-400" data-id="element-163" />
        </div>

        <h2 className="font-serif text-4xl lg:text-5xl mb-6" data-id="element-164">
          🤝 Garantía de Transformación de 7 Días
        </h2>

        <p className="text-xl text-gray-200 mb-8 leading-relaxed" data-id="element-165">
          Estoy tan segura de que este bundle va a cambiar tu vida, que te doy
          una garantía completa. Si en los próximos 7 días no sientes que estás
          en el camino correcto hacia tu transformación, te devuelvo tu dinero.{' '}
          <strong className="text-pink-400" data-id="element-166">
            Sin preguntas. Sin problemas.
          </strong>
        </p>

        <div className="bg-white/10 rounded-2xl p-8 mb-8 backdrop-blur-sm" data-id="element-167">
          <p className="text-lg text-gray-200" data-id="element-168">
            Pero aquí está la verdad: No vas a pedir tu dinero de vuelta. Porque
            desde la primera noche que duermas mejor, desde el primer momento
            que te sientas más segura, desde el primer peso que ahorres...{' '}
            <strong className="text-gold-400" data-id="element-169">
              vas a saber que tomaste la decisión correcta.
            </strong>
          </p>
        </div>

        <Button size="lg" href={CHECKOUT_URL} data-id="element-170">
          👉 Quiero empezar mi transformación ahora
        </Button>

        <p className="text-sm text-gray-400 mt-6" data-id="element-171">
          Compra 100% segura • Garantía de 7 días • Soporte en español
        </p>
      </div>
    </section>;
}